import { ASSETS } from '../assetManifest';

export const RESOURCES = {
  energy: {
    id: 'energy',
    name: 'Energy',
    icon: ASSETS.resources.energy.path,
    color: 'blue'
  },
  gold: {
    id: 'gold',
    name: 'Gold',
    icon: ASSETS.resources.spaceCoins.path,
    color: 'yellow'
  },
  stars: {
    id: 'stars',
    name: 'Stars',
    icon: ASSETS.resources.grandGems.path,
    color: 'purple'
  }
};
